import React, { useMemo } from 'react';
import { CorpUIResponse } from 'src/types/Corp';
import { CorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/CorporateFormContext';

export interface CorporateFormProviderProps {
  isEditPage?: boolean;
  corpData?: CorpUIResponse;
  isParentPage?: boolean;
  isChildPage?: boolean;
}

export const CorporateFormProvider: React.FC<CorporateFormProviderProps> = ({
  children,
  isEditPage = false,
  isParentPage = false,
  isChildPage = false,
  corpData,
}) => {
  const corporateFormContext = useMemo(
    () => ({
      isEditPage,
      corpData,
      isParentPage,
      isChildPage: Boolean(corpData?.parentId) || isChildPage,
    }),
    [isEditPage, corpData, isParentPage, isChildPage]
  );

  return (
    <CorporateFormContext.Provider value={corporateFormContext}>
      {children}
    </CorporateFormContext.Provider>
  );
};
